module.exports = __webpack_public_path__ + "img/13.1fe2d511.png";